import React from "react"

export const Exit = ({ style }) => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Exit</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-320.000000, -603.000000)">
        <g transform="translate(320.000000, 603.000000)">
          <g fill="#333333">
            <rect x="0" y="0" width="40" height="40" rx="20"></rect>
          </g>
          <g
            transform="translate(14.000000, 14.000000)"
            stroke="#EDDDC3"
            strokeLinecap="square"
            strokeWidth="4"
          >
            <path d="M12,0 L0,12" id="Line"></path>
            <path d="M0,0 L12,12" id="Line"></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const HowItWorks = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>How It Works</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-16.000000, -603.000000)">
        <g transform="translate(16.000000, 603.000000)">
          <g>
            <circle fill="#333333" cx="20" cy="20" r="20"></circle>
            <path
              d="M21.4736842,21.4991817 L21.4736842,20.6546645 C23.8164642,20.2815057 25.3846154,18.98527 25.3846154,16.3927987 C25.3846154,13.9181669 23.3630229,12.3076923 20.0944669,12.3076923 C16.5425101,12.3076923 14.6531714,13.9967267 14.6153846,17.492635 C17.1093117,17.492635 18.8475034,17.5515548 18.8475034,17.5515548 C18.8663968,16.3338789 19.0931174,15.4500818 19.9622132,15.4500818 C20.6234818,15.4500818 20.9446694,15.9803601 20.9446694,16.8052373 C20.9446694,18.1996727 19.9622132,18.5924714 17.317139,18.4353519 C17.317139,18.4353519 17.3738192,19.613748 17.3738192,21.5384615 C17.3738192,21.5384615 18.82861,21.4402619 21.4736842,21.4991817 Z M19.6945701,26.9230769 C21.2980769,26.9230769 22.3076923,26.0430248 22.3076923,24.6740548 C22.3076923,23.1877445 21.3970588,22.3076923 19.635181,22.3076923 C18.0514706,22.3076923 16.9230769,23.148631 16.9230769,24.5762712 C16.9230769,25.9061278 17.7941176,26.9230769 19.6945701,26.9230769 Z"
              fill="#EEDEC4"
              fillRule="nonzero"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const Indicator = ({ style, opacity = "0.5", color }) => (
  <svg
    style={{ opacity, ...style }}
    className="active"
    width="1em"
    height="1em"
  >
    <circle fill={color || "#333"} cx="0.5em" cy="0.5em" r="0.5em" />
  </svg>
)

export const Increment = ({ color }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 38 38"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Add to Bundle</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1362.000000, -121.000000)">
        <g transform="translate(20.000000, 13.000000)">
          <g transform="translate(1342.000000, 108.000000)">
            <polygon
              fill={color || "#333"}
              fillRule="nonzero"
              points="20.8076923 29 20.8076923 20.8076923 29 20.8076923 29 17.2307692 20.8076923 17.2307692 20.8076923 9 17.2307692 9 17.2307692 17.2307692 9 17.2307692 9 20.8076923 17.2307692 20.8076923 17.2307692 29"
            ></polygon>
            <circle
              stroke={color || "#333"}
              strokeWidth="4"
              cx="19"
              cy="19"
              r="17"
            ></circle>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const Decrement = ({ color }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 38 38"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Remove from Bundle</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1252.000000, -121.000000)">
        <g transform="translate(20.000000, 13.000000)">
          <g transform="translate(1232.000000, 108.000000)">
            <polygon
              fill={color || "#333"}
              fillRule="nonzero"
              points="20.8076923 20.8076923 29 20.8076923 29 17.2307692 20.8076923 17.2307692 17.2307692 17.2307692 9 17.2307692 9 20.8076923 17.2307692 20.8076923"
            ></polygon>
            <circle
              stroke={color || "#333"}
              strokeWidth="4"
              cx="19"
              cy="19"
              r="17"
            ></circle>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
